module.exports = __webpack_public_path__ + "static/carbon-table-search-5c58dba3cb53a66c4c1763671aba6e8e.png";